import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StakingconfirmPage } from './stakingconfirm';

@NgModule({
  declarations: [
    StakingconfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(StakingconfirmPage),
  ],
})
export class StakingconfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/stakingconfirm/stakingconfirm.module.ts